import accountsListQuery from '../../api-v2/queries/accounts-list-query';
import userListQuery from '../../api-v2/queries/user-list-query';

export const accountsPageLoader = (queryClient) => (opts) => {
  const url = new URL(opts.request.url);
  const page = url.searchParams.get('page') || 1;
  const pageSize = url.searchParams.get('pageSize') || 25;
  const sort = url.searchParams.get('sort') || 'name:asc';
  const search = url.searchParams.get('search') || '';
  const type = url.searchParams.get('type') || '';
  const user = url.searchParams.get('user') || '';

  queryClient.ensureQueryData(
    accountsListQuery({ page, pageSize, sort, filters: { search, type, user } }),
  );
  queryClient.ensureQueryData(userListQuery());

  return {
    page: parseInt(page, 10),
    pageSize: parseInt(pageSize, 10),
    sort,
    filters: { search, type, user },
  };
};

export default accountsPageLoader;
